<!-- <div class="row w100 align-end justify-end closerow" (click)="closeStream()">
  <rr-icon name="close" class="pointer"></rr-icon>
</div> -->

<div class="inner row gap-48">
    <div class="leftside col justify-center gap-48">
        <div class="col gap-16">
            <h1 i18n>Let's create your: {{ data.title }}!</h1>
            <div i18n>Don't worry! Johnny will guide you step by step.</div>
        </div>
        @if(data){
        <div class="bulletpoints col gap-20">
            @for( step of data.data; track step.name; let i = $index){
            <div class="row gap-8">
                <!-- <rr-icon name="arrow-right" color="nutral"></rr-icon> -->
                <h4 class="strong">{{ i + 1 }}.</h4>
                <div i18n class="col">
                    <h4 class="strong">{{ step.name }}</h4>
                    <div class="small">
                        {{ step.description }}
                    </div>
                </div>
            </div>
            }
        </div>
        }
        <!-- TODO: not sure why this is needed -->
        <!-- <div class="btnrow row gap-16 align-center"></div> -->
    </div>
    <div class="rightside col justify-center">
        <img src="images/bmc_init_picture.png" alt="Runner" />
    </div>
</div>
<div class="footer row align-center justify-start w100 gap-16">
    <rr-btn size="Medium" type="Primary" (click)="close()">Let's start</rr-btn>
    <rr-btn type="Link" size="Medium" (click)="closeStream()">Cancel</rr-btn>
</div>

